/* eslint-disable indent */
import { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import { getTranslation } from '../services/translations'
import u21Service from '../services/u21'

const AdminTools = ({
  user,
  updateAll,
  refreshMissingTeams,
  cleanupEmptyUsers,
  updateHanni,
  updateHanniItaly,
  syncNations,
  fixAll,
  fixMyPlayers,
  fixSinglePlayer,
  fixPlayerId,
  setFixPlayerId,
  rollbackSingle,
  rollbackMyTeam,
  rollbackAll,
  rollbackPlayerId,
  setRollbackPlayerId,
  recalc99Single,
  recalc99All,
  recalc99PlayerId,
  setRecalc99PlayerId,
  lang = 'fi',
}) => {
  const t = key => getTranslation(lang, key)

  const [u21Age, setU21Age] = useState('')
  const [u21Result, setU21Result] = useState(null)
  const [u21Loading, setU21Loading] = useState(false)

  const handleU21Search = async () => {
    if (!u21Age) return
    const parts = u21Age.split('.')
    if (parts.length !== 2) return
    const years = parseInt(parts[0])
    const days = parseInt(parts[1])
    if (isNaN(years) || isNaN(days)) return

    setU21Loading(true)
    try {
      const result = await u21Service.getEligibility(years, days)
      setU21Result(result)
    } catch (error) {
      setU21Result({ error: error.response?.data?.error || 'Virhe haussa' })
    }
    setU21Loading(false)
  }

  // Näytä vain Mizi91-käyttäjälle
  if (!user || user.loginName !== 'Mizi91') {
    return null
  }

  return (
    <div style={{ marginBottom: '20px' }}>
      <h5>{t('adminTools')}</h5>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        <Button variant="dark" onClick={updateAll} size="sm">
          {t('updateAllPlayers')}
        </Button>
        <Button variant="outline-light" onClick={refreshMissingTeams} size="sm">
          {t('refreshMissingTeams')}
        </Button>
        <Button variant="danger" onClick={cleanupEmptyUsers} size="sm">
          Siivoa tyhjät käyttäjät
        </Button>
        <Button variant="warning" onClick={fixAll} size="sm">
          🔧 Fix All Players
        </Button>
        <Button variant="warning" onClick={fixMyPlayers} size="sm">
          🔧 Fix My Players
        </Button>
        <InputGroup size="sm">
          <Form.Control
            type="text"
            placeholder="Player ID"
            value={fixPlayerId}
            onChange={e => setFixPlayerId(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && fixSinglePlayer()}
          />
          <Button variant="warning" onClick={fixSinglePlayer}>
            🔧 Fix
          </Button>
        </InputGroup>
        <Button variant="dark" onClick={updateHanni} size="sm">
          Hanni
        </Button>
        <Button variant="dark" onClick={updateHanniItaly} size="sm">
          Hitaly
        </Button>
        <Button variant="info" onClick={syncNations} size="sm">
          {t('syncNationData')}
        </Button>

        <hr style={{ borderColor: '#555', margin: '8px 0' }} />
        <h6>⏪ Rollback</h6>
        <InputGroup size="sm">
          <Form.Control
            type="text"
            placeholder="Player ID"
            value={rollbackPlayerId}
            onChange={e => setRollbackPlayerId(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && rollbackSingle()}
          />
          <Button variant="secondary" onClick={rollbackSingle}>
            ⏪ Rollback
          </Button>
        </InputGroup>
        <Button variant="secondary" onClick={rollbackMyTeam} size="sm">
          ⏪ Rollback My Team
        </Button>
        <Button variant="danger" onClick={rollbackAll} size="sm">
          ⏪ Rollback All
        </Button>

        <hr style={{ borderColor: '#555', margin: '8px 0' }} />
        <h6>🔄 Recalc-99</h6>
        <InputGroup size="sm">
          <Form.Control
            type="text"
            placeholder="Player ID"
            value={recalc99PlayerId}
            onChange={e => setRecalc99PlayerId(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && recalc99Single()}
          />
          <Button variant="primary" onClick={recalc99Single}>
            🔄 Recalc
          </Button>
        </InputGroup>
        <Button variant="primary" onClick={recalc99All} size="sm">
          🔄 Recalc-99 All
        </Button>

        <hr style={{ borderColor: '#555', margin: '8px 0' }} />
        <h6>🏆 U21 Ikälaskuri</h6>
        <InputGroup size="sm">
          <Form.Control
            type="text"
            placeholder="Ikä (esim. 17.23)"
            value={u21Age}
            onChange={e => setU21Age(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleU21Search()}
          />
          <Button
            variant="info"
            onClick={handleU21Search}
            disabled={u21Loading}
          >
            {u21Loading ? '...' : '🔍 Laske'}
          </Button>
        </InputGroup>

        {u21Result && !u21Result.error && (
          <div
            style={{
              marginTop: '6px',
              padding: '8px',
              backgroundColor: '#1a1a2e',
              borderRadius: '6px',
              fontSize: '0.85rem',
              color: '#e0e0e0',
            }}
          >
            <div style={{ marginBottom: '4px' }}>
              <strong>Ikä:</strong> {u21Result.pelaajanIka} &nbsp;|&nbsp;
              <strong>Päiviä jäljellä:</strong> {u21Result.paiviiaJaljella}
            </div>
            <div style={{ marginBottom: '6px' }}>
              <strong>Yhteensä:</strong> MMK{' '}
              <span style={{ color: '#4fc3f7' }}>{u21Result.yhteensa.mmk}</span>{' '}
              | WC{' '}
              <span style={{ color: '#81c784' }}>{u21Result.yhteensa.wc}</span>{' '}
              | Kaikki{' '}
              <span style={{ color: '#ffb74d' }}>
                {u21Result.yhteensa.kaikki}
              </span>
            </div>
            <table
              style={{
                width: '100%',
                fontSize: '0.8rem',
                borderCollapse: 'collapse',
              }}
            >
              <thead>
                <tr style={{ borderBottom: '1px solid #444' }}>
                  <th style={{ textAlign: 'left', padding: '2px 4px' }}>
                    Turnaus
                  </th>
                  <th style={{ textAlign: 'center', padding: '2px 4px' }}>
                    MMK
                  </th>
                  <th style={{ textAlign: 'center', padding: '2px 4px' }}>
                    WC
                  </th>
                </tr>
              </thead>
              <tbody>
                {u21Result.turnaukset.map(t => (
                  <tr
                    key={t.turnaus}
                    style={{ borderBottom: '1px solid #333' }}
                  >
                    <td style={{ padding: '2px 4px' }}>T{t.turnaus}</td>
                    <td style={{ textAlign: 'center', padding: '2px 4px' }}>
                      <span
                        style={{
                          color:
                            t.mmk.ikakelpoisia === t.mmk.yhteensa
                              ? '#81c784'
                              : t.mmk.ikakelpoisia === 0
                              ? '#e57373'
                              : '#ffb74d',
                        }}
                      >
                        {t.mmk.ikakelpoisia}
                      </span>
                      /{t.mmk.yhteensa}
                      {t.mmk.olisiVoinutPelata > 0 && (
                        <span style={{ color: '#888' }}>
                          {' '}
                          ({t.mmk.olisiVoinutPelata}✓)
                        </span>
                      )}
                    </td>
                    <td style={{ textAlign: 'center', padding: '2px 4px' }}>
                      {t.wc.kierrokset ? (
                        <span>
                          {t.wc.kierrokset.map((r, i) => (
                            <span key={r.kierros}>
                              {i > 0 && ' '}
                              <span
                                style={{ color: '#aaa', fontSize: '0.7rem' }}
                              >
                                {r.nimi}
                              </span>
                              <span
                                style={{
                                  color:
                                    r.ikakelpoisia === r.yhteensa
                                      ? '#81c784'
                                      : r.ikakelpoisia === 0
                                      ? '#e57373'
                                      : '#ffb74d',
                                }}
                              >
                                {r.ikakelpoisia}
                              </span>
                              <span style={{ color: '#666' }}>
                                /{r.yhteensa}
                              </span>
                            </span>
                          ))}
                        </span>
                      ) : (
                        <span>
                          <span
                            style={{
                              color:
                                t.wc.ikakelpoisia === t.wc.yhteensa
                                  ? '#81c784'
                                  : t.wc.ikakelpoisia === 0
                                  ? '#e57373'
                                  : '#ffb74d',
                            }}
                          >
                            {t.wc.ikakelpoisia}
                          </span>
                          /{t.wc.yhteensa}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div
              style={{
                marginTop: '6px',
                fontSize: '0.75rem',
                color: '#aaa',
              }}
            >
              Optimi: MMK {u21Result.optimiIat?.mmk?.optimi?.ika || '-'} | WC{' '}
              {u21Result.optimiIat?.wc?.optimi?.ika || '-'} (3 turnausta)
            </div>
          </div>
        )}

        {u21Result?.error && (
          <div
            style={{
              marginTop: '6px',
              padding: '6px',
              backgroundColor: '#3e1111',
              borderRadius: '4px',
              fontSize: '0.85rem',
              color: '#e57373',
            }}
          >
            {u21Result.error}
          </div>
        )}
      </div>
    </div>
  )
}

export default AdminTools
